'use client';

import {
  IoBugOutline,
  IoBuildOutline,
  IoCloudDownloadOutline,
} from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { IconButton } from '../../icon-button';
import { CloseButton, ResourceBar } from '../../resource';

type ContainerProps = BaseComponentProps & {
  onDownload?: () => void;
  onFeedback?: () => void;
  onEdit?: () => void;
  onClose?: () => void;
};

function Header({
  style,
  className,
  onDownload,
  onFeedback,
  onEdit,
  onClose,
}: ContainerProps) {
  return (
    <ResourceBar
      style={style}
      className={className}
      edge="top"
      layout="split"
      start={
        <>
          {onDownload && (
            <IconButton
              icon={<IoCloudDownloadOutline />}
              aria-label="Descargar imagen"
              onClick={onDownload}
            />
          )}
          {onFeedback && (
            <IconButton
              icon={<IoBugOutline />}
              aria-label="Enviar comentarios"
              onClick={onFeedback}
            />
          )}
          {onEdit && (
            <IconButton
              icon={<IoBuildOutline />}
              aria-label="Editar imagen"
              onClick={onEdit}
            />
          )}
        </>
      }
      end={onClose && <CloseButton onClose={onClose} />}
    />
  );
}

export { Header };
